import React, { useEffect, useState, useRef } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Carousel, { CarouselItem } from './Carousel';

const useStyles = makeStyles(theme => ({
  documentLabel: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2)
  }
}));

interface DocumentProcessorProps {
  documentsData: any;
}

const DocumentProcessor = (props: DocumentProcessorProps) => {
  const classes = useStyles();
  let { documentsData } = props;
  let documentsLength = documentsData && documentsData.length;

  let renderDocumentLabel = (item: any) => {
    return (
      <Typography variant="h3" color="textPrimary" className={classes.documentLabel}>
        {'File name: '}
        {item.fileName}
      </Typography>
    );
  };

  let renderDocument = (item: any) => {
    switch (item?.fileExtension) {
      case 'jpeg':
        return renderImage(item);
      case 'png':
        return renderImage(item);
      case 'gif':
        return renderGIF(item);
      default:
        return renderNoPreview();
    }
  };

  const renderImage = (item: any) => {
    return <img src={`data:image/gif;base64,${item.documentContent}`} style={{ width: '60%' }} />;
  };

  const renderGIF = (item: any) => {
    return <img src={`data:image/gif;base64,${item.documentContent}`} style={{ width: '60%' }} />;
  };

  const renderNoPreview = () => {
    return (
      <Typography variant="h3" color="textPrimary" className={classes.documentLabel}>
        {'Document does not support preview'}
      </Typography>
    );
  };

  return (
    <>
      {documentsData && documentsData.length > 0 ? (
        <Carousel documentsLength={documentsLength}>
          {documentsData &&
            documentsData.map((item: { documentContent: any }) => (
              <CarouselItem>
                <div>
                  {renderDocumentLabel(item)}
                  {renderDocument(item)}
                </div>
              </CarouselItem>
            ))}
        </Carousel>
      ) : (
        <div>No Documents are available to Preview.</div>
      )}
    </>
  );
};

export default DocumentProcessor;
